import { CountryCode } from '@link/share/services/const';

export const CountryCodeLevel: Partial<Record<CountryCode, number>> = {
  [CountryCode.Jpn]: 5,
  [CountryCode.Chn]: 4,
  [CountryCode.Kor]: 3,
  [CountryCode.Twn]: 2,
  [CountryCode.Hkg]: 1
};

export const CONTRACTS_URL = 'contracts';
export const PAGE_SIZE = 20;

export const MAX_IMAGE_SIZE = 5;
export const IMAGE_ACCEPT = '.png,.jpg,.jpeg,.svg';
export const FILE_ACCEPT =
  '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv,.rtf';
export const LOGO_FOLDER = 'gds-neo-static/admin/account/logo/';
export const SUPPLIER_FILE_FOLDER = 'gds-neo-static/supplier/file/';
export const INVOICE_FILE_FOLDER = 'gds-neo-static/invoice/file/';

export const STATIC_HOST = import.meta.env.VITE_APP_STATIC_HOST;
// 站内信（Inbox）开关，仅在值为 'true' 时开放；未设置时视为关闭
export const INBOX_ENABLED = import.meta.env.VITE_APP_INBOX_ENABLED === 'true';
export const SEPARATOR = ',';
//新接口角色分配
// 账号角色
// enum Role {
// UNDEFINED_ROLE = 0; // 未定义
// ADMIN = 1; // 管理员角色
// VIEWER = 2; // 查看角色
// EDITOR = 3; // 编辑角色
// OPERATOR = 4; // 操作员角色
// LINK_ADMIN = 5; // Linktivity管理员角色
// SUPERVISOR = 6; // 监督角色
// }
export const ROLE = {
  ADMIN: 'ADMIN',
  LINK_ADMIN: 'LINK_ADMIN',
  SUPERVISOR: 'SUPERVISOR',
  OPERATOR: 'OPERATOR',
  EDITOR: 'EDITOR',
  VIEWER: 'VIEWER'
};
export const ACCESS_TOKEN = 'accessToken';
export const MAX_REFRESH_COUNT = 10;
export const TIMEOUT = 300;

export const AGENT_DEFAULT_ORG = '0';
export const EMPTY = '-';

export const WEEKDAYS = [
  'sun',
  'mon',
  'tue',
  'wed',
  'thu',
  'fri',
  'sat'
] as const;
export type Weekday = (typeof WEEKDAYS)[number];

export const CALENDAR_ROW = 6;
export const CALENDAR_COL = 7;

export const MAX_SEARCH_MOUNTH = 3;

export const HALF_MONTH = 15;

export const DEPOSIT_FEE_RATE = 0.036;
